document.addEventListener('DOMContentLoaded', function () {
  const firstNameInput = document.querySelector('#ContactFooter .newsletter-name__input');
  const emailInput = document.querySelector('#ContactFooter .newsletter-email__input');
  const phoneInput = document.querySelector('#ContactFooter .newsletter-number__input');
  const nameErrorElement = document.querySelector('.error');
  const phoneErrorElement = document.querySelector('.number-error');
  const emailErrorElement = document.querySelector('.email-error');
  const submitButton = document.querySelector('.button-newsletter #Subscribe');

  // Validate the first name input
  function validateFirstName() {
    const nameRegex = /^[A-Za-z\s]+$/;
    if (firstNameInput.value.trim() === '') {
      nameErrorElement.textContent = "Please enter your First Name.";
      nameErrorElement.classList.remove('hidden');
      emailErrorElement.classList.add('hidden');
      return false;
    } else if (!nameRegex.test(firstNameInput.value.trim())) {
      nameErrorElement.textContent = 'Only letters and spaces are allowed.';
      nameErrorElement.classList.remove('hidden');
      emailErrorElement.classList.add('hidden');
      return false;
    } else {
      nameErrorElement.classList.add('hidden');
      return true;
    }
  }

  // Validate the email input
  function validateEmail() {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
    if (emailInput.value.trim() === '') {
      emailErrorElement.textContent = "Please enter your Email Address.";
      emailErrorElement.classList.remove('hidden');
      nameErrorElement.classList.add('hidden');
      return false;
    } else if (!emailRegex.test(emailInput.value.trim())) {
      emailErrorElement.textContent = 'Please enter a valid Email Address.';
      emailErrorElement.classList.remove('hidden');
      nameErrorElement.classList.add('hidden');
      return false;
    } else {
      emailErrorElement.classList.add('hidden');
      return true;
    }
  }

  // Validate the phone number input
  function validatePhone() {
    const phoneRegex = /^\+?[0-9]{7,15}$/;
    if (phoneInput.value.trim() === '') {
      // phoneErrorElement.textContent = "Please enter your Phone Number.";
      // phoneErrorElement.classList.remove('hidden');
      nameErrorElement.classList.add('hidden');
      emailErrorElement.classList.add('hidden');
      return false;

    } else if (!phoneRegex.test(phoneInput.value.trim())) {
      // phoneErrorElement.textContent = "Please enter a valid 10-digit Phone Number.";
      // phoneErrorElement.classList.remove('hidden');
      nameErrorElement.classList.add('hidden');
      emailErrorElement.classList.add('hidden');
      return false;
    } else {
      phoneErrorElement.classList.add('hidden');
      if (phoneInput.value.trim().length >= 10) {
        const phone = phoneInput?.value
        document.querySelector('#customerNote').value = `Phone: ${phone}`;
      }
      return true;
    }
  }

  // Check overall form validity and enable/disable submit button
  function updateButtonState() {
    const isFormValid = validateFirstName() && validateEmail();
    if (isFormValid) {
      submitButton.disabled = false;
      submitButton.classList.remove('disabled');
    } else {
      submitButton.disabled = true;
      submitButton.classList.add('disabled');
    }
  }

  // Input event listeners for immediate validation
  firstNameInput?.addEventListener('input', function () {
    document.querySelector('.newsletter-success__text')?.classList.add('hidden');
    validateFirstName(); // Validate first name field
    updateButtonState(); // Update button state based on overall validity
  });

  emailInput?.addEventListener('input', function () {
    document.querySelector('.newsletter-success__text')?.classList.add('hidden');
    const newsName = validateFirstName();
    if (newsName == true) {
      validateEmail(); 
    }
    updateButtonState(); // Update button state based on overall validity
  });

  phoneInput?.addEventListener('input', function () {
    document.querySelector('.newsletter-success__text')?.classList.add('hidden');
    const newsName = validateFirstName();
    const emailValidate = validateEmail ();
    if (newsName == true && emailValidate == true) {
      validatePhone(); 
    }
  });

  submitButton?.addEventListener('click', () => {
    document.querySelector('.newsletter-success__text')?.classList.add('hidden');
    const firstName = validateFirstName();
    let email = false
    if (firstName == true) {
      email = validateEmail(); 
    }
    if (firstName && email) {
      const formsubmit = submitButton.closest('.newsletter-form__field-wrapper')?.querySelector('.newsletter-submit-button');
      if(formsubmit)formsubmit.click();
    }
  })

});